import { useRef } from "react";

const ACCENT = "#FF6B00";
const MIN = 1;
const MAX = 10;

export default function CreditSlider({ value, onChange }) {
  const trackRef = useRef(null);
  const dragging = useRef(false);

  const positionFromValue = (v) => ((v - MIN) / (MAX - MIN)) * 100;

  const updateFromClientX = (clientX) => {
    const el = trackRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const pct = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
    const raw = MIN + pct * (MAX - MIN);
    onChange(Math.round(raw));
  };

  const onDown = (e) => {
    e.preventDefault();
    dragging.current = true;
    const x = e.touches ? e.touches[0].clientX : e.clientX;
    updateFromClientX(x);
    const onMove = (ev) => {
      if (!dragging.current) return;
      if (ev.touches) ev.preventDefault();
      const cx = ev.touches ? ev.touches[0].clientX : ev.clientX;
      updateFromClientX(cx);
    };
    const onUp = () => {
      dragging.current = false;
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
      window.removeEventListener("touchmove", onMove);
      window.removeEventListener("touchend", onUp);
    };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
    window.addEventListener("touchmove", onMove, { passive: false });
    window.addEventListener("touchend", onUp);
  };

  const pos = positionFromValue(value);

  return (
    <div className="upg-cs-wrap">
      <div className="upg-cs-row">
        <div
          className="upg-cs-track"
          ref={trackRef}
          onMouseDown={onDown}
          onTouchStart={onDown}
        >
          <div
            className="upg-cs-fill"
            style={{ width: `${pos}%`, background: ACCENT }}
          />
          <div className="upg-cs-ticks">
            {Array.from({ length: MAX - MIN + 1 }).map((_, i) => (
              <span key={i} className="upg-cs-tick" />
            ))}
          </div>
          <div
            className="upg-cs-knob"
            style={{ left: `${pos}%`, borderColor: ACCENT }}
            onMouseDown={onDown}
            onTouchStart={onDown}
          >
            <span>{value}x</span>
          </div>
        </div>
        <div className="upg-cs-pack-stepper">
          <span>{value} {value === 1 ? "pack" : "packs"}</span>
          <div className="upg-cs-pack-arrows">
            <button onClick={() => onChange(Math.min(MAX, value + 1))} aria-label="More packs">
              <svg width="9" height="6" viewBox="0 0 9 6" fill="none">
                <path d="M1 5l3.5-4L8 5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
              </svg>
            </button>
            <button onClick={() => onChange(Math.max(MIN, value - 1))} aria-label="Fewer packs">
              <svg width="9" height="6" viewBox="0 0 9 6" fill="none">
                <path d="M1 1l3.5 4L8 1" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
